// menu-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from '../common/sidebar/sidebar-menu';

@Injectable({ providedIn: 'root' })
export class MenuStateService {
  private menuSubject = new BehaviorSubject<MenuItem[]>([]);
  menu$ = this.menuSubject.asObservable();

  setMenu(menu: MenuItem[]) {
    this.menuSubject.next(menu);
  }

  getMenuSnapshot(): MenuItem[] {
    return this.menuSubject.value;
  }
}
